// @flow

export default (store: Object) => ({
  path: '/login',
  children: [
    require('./Login').default(store),
  ]
})
